<!--
  FormLabel.vue

  This component adds a label with the asterisk and spacing for form labels.

  Following are supported attributes:
    - forId: ID of the input element the label is for
    - text: Text to display inside the label
    - required: If set (as 'required' or 'required=true' or 'required=false'),
                form input is rendered with asterisk for required. Defaults to true
-->

<template>
  <label class="form-field-label" :for="forId">
    <span>{{ labelText }}</span>
    <span v-if="required" class="required-input">*</span>
  </label>
</template>

<script>
export default {
  name: 'FormLabel',

  props: {
    /**
     * The id of the input that the label is for
     * @type String
     * @values Any string value
     */
    forId: {
      type: String,
    },

    /**
     * The value of the actual label text.
     * @type String
     * @values Any string value
     */
    labelText: {
      type: String,
    },

    /**
     * Flag to track if the label should have a required asterisk next to it.
     * @type Boolean
     * @values none, true, false
     * @default true
     */
    required: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  display: block;
  font-weight: $BOLD;
  margin-bottom: 10px;
  white-space: break-spaces;

  > .required-input {
    color: $NEUTRAL_MIDNIGHT;
  }
}
</style>
